import React, { Component } from "react";
import { Select, Table, Input, InputNumber, Form, Button } from 'antd';
import moment from 'moment';


// We import our firestore module
import { db } from '../firebase/firebase';


const Option2 = Select.Option;

const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  getInput = () => {
    if (this.props.inputType === 'number') {
      return <InputNumber />;
    }
    return <Input />;
  };

  render() {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      ...restProps
    } = this.props;
    return (
      <EditableContext.Consumer>
        {(form) => {
          const { getFieldDecorator } = form;
          return (
            <td {...restProps}>
              {editing ? (
                <FormItem style={{ margin: 0 }}>
                  {getFieldDecorator(dataIndex, {
                    rules: [{
                      required: false,
                      message: `Please Input ${title}!`,
                    }],
                    initialValue: record[dataIndex],
                  })(this.getInput())}
                </FormItem>
              ) : restProps.children}
            </td>
          );
        }}
      </EditableContext.Consumer>
    );
  }
}

export class EditableTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      major: [],
      editingKey: '',
      pa: null,
      ta: null,
      xa: null,
      ya: null,
      sa: null,
      ca: null
    };
    this.columns = [
      // {
      //   title: 'PK',
      //   dataIndex: 'key',
      //   width: '5%',
      //   editable: false,
      // },
      {
        title: 'Type',
        dataIndex: 'unittype',
        editable: true,
        width: '10%',
        sorter: (a, b) => { return a.unittype.localeCompare(b.unittype) },
      },
      {
        title: 'Name',
        dataIndex: 'lot',
        editable: true,
        width: '13%',
        sorter: (a, b) => { return a.lot.localeCompare(b.lot) },
      },
      {
        title: 'Unit',
        dataIndex: 'unitno',
        width: '9%',
        editable: true,
        sorter: (a, b) => { return a.unitno.localeCompare(b.unitno) },
      },
      {
        title: 'Size',
        dataIndex: 'size',
        width: '10%',
        editable: true,
        sorter: (a, b) => { return a.size.localeCompare(b.size) },
        onHeaderCell: (column) => {
          return {
            onClick: () => {
              console.log('onClick');
            }
          };
        }
      },
      {
        title: 'Price',
        dataIndex: 'price',
        width: '12%',
        editable: true,
        sorter: (a, b) => parseInt(a.price, 10) - parseInt(b.price, 10),
      },
      {
        title: 'Customer',
        dataIndex: 'customer',
        editable: true,
        sorter: (a, b) => { return a.customer.localeCompare(b.customer) },
      },
      {
        title: 'Sale',
        dataIndex: 'isSold',
        width: '9%',
        render: (text, record) => {
          const editable = this.isEditing(record);

          return (
            <div>
              {editable ? (
                <div>
                  <Select style={{ width: 120 }} defaultValue={this.state.data[record.key].isSold} onChange={(value) => this.sect2(record.key, value)}>
                    <Option2 value="Open">Open</Option2>
                    <Option2 value="Sold">Sold</Option2>
                  </Select>
                </div>
              ) : (
                  <div>
                    {this.state.data[record.key].isSold}
                  </div>
                )}
            </div>
          );
        },
      },
      {
        title: '',
        dataIndex: 'operation',
        width: '15%',
        render: (text, record) => {
          const editable = this.isEditing(record);

          return (
            <div>
              {editable ? (
                <span>
                  <EditableContext.Consumer>
                    {form => (
                      <a
                        href="javascript:;"
                        onClick={() => this.save(form, record.key)}
                        style={{ marginRight: 8 }}
                      >
                        Save
                      </a>
                    )}
                  </EditableContext.Consumer>
                  <a
                    href="javascript:;"
                    style={{ marginRight: 8 }}
                    onClick={() => this.cancel(record.key)}
                  >
                    Cancel
                  </a>
                </span>
              ) : (
                  <div>
                    <Button
                      onClick={() => this.edit(record.key)}
                      className="App-t"
                    >
                      Edit
                </Button>
                    {/* THIS IS THE DELETE BUTTON (TURNED OFF BY REQUEST) */}
                    {/* <Divider type="vertical" />
                    <Popconfirm
                      title="Confirm Delete?"
                      onConfirm={evt => this.deleteProject(record.key)}
                    >
                      <Button>Delete</Button>
                    </Popconfirm> */}

                  </div>
                )}
            </div>
          );
        },
      },
    ];


    this.addProject = this.addProject.bind(this);
    this.deleteProject = this.deleteProject.bind(this);
    this.updateProject = this.updateProject.bind(this);
    this.exportFile = this.exportFile.bind(this)
    this.pullFromDB();
  }



  id2name(id) {

  }


  pullFromDB() {
    var baba;
    if (this.props.match.params.id) {
      baba = this.props.match.params.id
    }
    // We listen for live changes to our data collection in Firebase
    db.collection("units").where("projects", "==", baba).onSnapshot(snapshot => {
      //data is locally available array, pulled from firestore.
      let data = [];
      snapshot.forEach(doc => {
        const todo = doc.data();
        todo.id = doc.id;
        data.push(todo);
      });

      // Sort our data based on time added
      data.sort(function (a, b) {
        return (
          new Date(b.date).getTime() - new Date(a.date).getTime()
        );
      });

      //assign primary key
      for (var i = 0; i < data.length; i++) {
        data[i].key = i;
      }



      // Anytime the state of our database changes, we update state
      this.setState({ data });

    })
  }

  sect(key, value) {
    this.state.data[key].type = value;
  }

  sect2(key, value) {
    this.state.data[key].isSold = value;
  }

  async deleteProject(id) {
    // alert("record.key: " + id + "todo id: " + this.state.data[id].id)
    await db
      .collection("units")
      .doc(this.state.data[id].id)
      .delete();
  }

  async updateProject(id) {
    // alert("update! record.key: " + id + "todo id: " + this.state.data[id].id)
    // alert("firebasing the pa ta xa...: " + this.state.pa + this.state.ta + this.state.xa + this.state.ya + this.state.sa)
    await db
      .collection("units")
      .doc(this.state.data[id].id).update({
        price: this.state.pa,
        xx: this.state.xa,
        yy: this.state.ya,
        isSold: this.state.sa,
        customer: this.state.ca
      })
      .then(function () {
        console.log("Document successfully updated!");

      })
      .catch(function (error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
      });
  }


  async addProject() {
    var na = moment()
    var bb = await db.collection("units").add({
      date: na.toISOString(),
      key: 1,
      unittype: "ba",
      customer: "",
      projects: this.props.match.params.id,
      lot: "test",
      unitno: "test",
      price: "123",
      size: "321",
      xx: 1,
      yy: 1,
      isSold: "Open",
    });

    // this.pullFromDB();

  }











  isEditing = (record) => {
    return record.key === this.state.editingKey;
  };

  edit(key) {
    this.setState({ editingKey: key });
  }

  save(form, key) {
    form.validateFields((error, row) => {
      if (error) {
        return;
      }
      const newData = [...this.state.data];
      const index = newData.findIndex(item => key === item.key);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });

        if (!/^-?\d*[.,]?\d{0,2}$/.test(newData[index].price)) {
          alert('Numbers only. Decimal point is allowed.')
        } else {

          //do not remove one of these five item, or it will become null!


          db.collection("units")
            .doc(this.state.data[index].id).update({
              unittype: newData[index].unittype,
              lot: newData[index].lot,
              unitno: newData[index].unitno,
              size: newData[index].size,
              price: newData[index].price,
              xx: newData[index].xx,
              yy: newData[index].yy,
              isSold: newData[index].isSold,
              customer: newData[index].customer
            })
            .then(function () {
              console.log("Document successfully updated!");

            })
            .catch(function (error) {
              // The document probably doesn't exist.
              console.error("Error updating document: ", error);
            });

          // alert("OLD DATA: " + JSON.stringify(this.state.data[index]))
          // alert("the pa ta xa...: " + this.state.pa + this.state.ta + this.state.xa + this.state.ya + this.state.sa)

          // this.updateProject(index)
          this.setState({ data: newData, editingKey: '' });
        }
      } else {
        newData.push(row);
        this.setState({ data: newData, editingKey: '' });
      }
    });
  }

  cancel = () => {
    this.setState({ editingKey: '' });
  };


  exportFile() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      alert('This feature is only on PC.')
    } else {
      this.state.major = [];
      var i;
      for (i = 0; i < this.state.data.length; i++) {
        var lol = [this.state.data[i].id, this.state.data[i].unitno, this.state.data[i].lot, this.state.data[i].unittype, this.state.data[i].price, this.state.data[i].size, this.state.data[i].xx, this.state.data[i].yy, this.state.data[i].isSold, this.state.data[i].customer];
        this.state.major.push(lol)
      }

      // console.log(this.state.major)
      // alert("the string: " + this.state.major.toString())
      alert(this.state.major.length + " records ready to download")
      if (this.state.major.length > 1)
        this.downloadcsv();
    }

  }

  downloadcsv = (e) => {
    // console.log("heyy2 " + this.state.major);
    var csv = 'doc_id,unitno,lot,unittype,price,size,xx,yy,isSold,customer\n';
    this.state.major.forEach(function (row) {
      csv += row.join(',');
      csv += "\n";
    });

    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
    hiddenElement.target = '_blank';
    hiddenElement.download = this.props.match.params.name + '.csv';
    hiddenElement.click();
  }







  render() {
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };

    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          inputType: col.dataIndex === 'price' ? 'text' : 'text',
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
        }),
      };
    });

    return (
      <div>
        <h1>{this.props.match.params.name}</h1>
        <div className="csvbtn" >
          <Button onClick={this.exportFile}>Export to CSV</Button>
          <Button
            type="secondary"
            onClick={this.addProject}
          >
            Add a project
          </Button>
        </div>

        <Table
          className='tably'
          components={components}
          bordered
          dataSource={this.state.data}
          columns={columns}
          pagination={{ pageSize: 50 }}
          rowClassName="editable-row"
        />
      </div>
    );
  }
}

export default EditableTable;




// WEBPACK FOOTER //
// ./src/views/projects.js